export type CentralBank =
  | "rba"
  | "rbnz"
  | "fed"
  | "boe"
  | "ecb"
  | "bi"
  | "boj"
  | "pbc"
  | "mas";

export const centralBankLookup: Record<CentralBank, string> = {
  rba: "RBA",
  rbnz: "RBNZ",
  fed: "Fed",
  boe: "BoE",
  ecb: "ECB",
  bi: "BI",
  boj: "BoJ",
  pbc: "PBC",
  mas: "MAS",
};

export const centralBankLookupLong: Record<CentralBank, string> = {
  rba: "Reserve Bank of Australia",
  rbnz: "Reserve Bank of New Zealand",
  fed: "US Federal Reserve",
  boe: "Bank of England",
  ecb: "European Central Bank",
  bi: "Bank Indonesia",
  boj: "Bank of Japan",
  pbc: "People's Bank of China",
  mas: "Monetary Authority of Singapore",
};
